import { FC, useEffect } from 'react';

import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';

import useAuth from 'hooks/auth/use-auth';
import useAuthRedirects from 'hooks/auth/use-auth-redirects';
import { useMParticleContext } from 'state/mParticle';
import { useOffersContext } from 'state/offers';
import { routes } from 'utils/routing';
import { toast } from 'utils/toast';

import { messages } from './messages';
import { IOfferActivatePageProps } from './types';

const OfferActivatePage: FC<IOfferActivatePageProps> = ({ tokenId, offerId }) => {
  const { isAuthenticated } = useAuth();
  const { logOfferActivatedEvent } = useMParticleContext();
  const { activateOffer } = useOffersContext();
  const { formatMessage } = useIntl();
  const navigate = useNavigate();

  useAuthRedirects();

  useEffect(() => {
    if (isAuthenticated()) {
      activateOffer(tokenId)
        .then(({ isOfferActivated }) => {
          if (isOfferActivated) {
            logOfferActivatedEvent(offerId, '', tokenId);
            toast.success(formatMessage(messages.offerActivationSuccess));
            return;
          }
          toast.error(formatMessage(messages.offerActivationError));
        })
        .catch(() => {
          toast.error(formatMessage(messages.offerActivationError));
        })
        .finally(() => {
          navigate(routes.base, { replace: true });
        });
    }
  }, [
    activateOffer,
    formatMessage,
    isAuthenticated,
    logOfferActivatedEvent,
    navigate,
    offerId,
    tokenId,
  ]);
  return null;
};

export default OfferActivatePage;
